import { NotificationService } from './../../feature/main/roles-shared/services/notification.service';
import { Component, OnInit, OnDestroy, AfterViewInit, NgZone, Input, Output, EventEmitter } from "@angular/core";
import { AppStateService } from "@app/shared/services/app-state.service";
import { AccountService } from "@app/feature/external/account/shared/services/account.service";
import swal from "sweetalert2";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { environment } from "@env/environment";
import { AccessToken as MyAccessToken } from "@app/util/accessToken";
import { UserDetailService } from "@app/feature/main/roles-shared/services/user-detail.service";
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { RolesSharedService } from "@app/feature/main/roles-shared/services/roles-shared.service";
import { TechDomainService } from "@app/shared/services/tech-domain.service";
import { Subscription } from "rxjs/Subscription";
import { WebSocketService } from '@app/feature/main/roles-shared/services/web-socket.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HomeAccountDetails } from '@app/feature/main/roles-shared/models/homeModel';
import { GlobalDataSharedService } from '@app/feature/main/roles-shared/services/global-data-shared-service.service';
declare var $: any;
@Component({
  selector: "app-top-nav-bar",
  templateUrl: "./top-nav-bar.component.html",
  styleUrls: ["./top-nav-bar.component.css"]
})
export class TopNavBarComponent implements OnInit, OnDestroy, AfterViewInit {
 toggleSidebar: boolean = true;
  @Output() leftSideMenuBar = new EventEmitter<boolean>();
  loggedIn = false;
  userId = "";
  accountDetailsObject = new HomeAccountDetails();
  accessToken: string;
  userRole: string;
  userDetailsObject: any;
  checkProfileUrlChange: any;
  checkCartChange: any;
  notificationChange: any
  blogURL: string;
  ECOSYSTM_TV_URL: string;
  EVENTS_URL: string;
  wpAutoLoginUrl: string = '';
  windowInnerWith: number;
  cartData: any;
  cartLength: any;
  techDomainData;
  techDomainListselected = {id: null, name: "View All"};
  subscription: Subscription;
  notificationCount : number;
  searchDisplay: boolean = false;
  searchString: string;
  limit = 10;
  skip = 0;
  searchType : string = "";
  researchStl: boolean = false;
  reportStl: boolean = false
  mediaURL: string;
  aboutUsStl: boolean = false;
  contactUsStl: boolean = false;
  profileCompleted;
  leftMenuExpand = false;

  constructor(
    private router: Router,
    private appState: AppStateService,
    private breadcrumService: BreadcrumService,
    private authenticationService: AuthenticationService,
    private globalDataSharedService: GlobalDataSharedService,
    private myAccessToken: MyAccessToken,
    private userDetailService: UserDetailService,
    public rolesSharedService: RolesSharedService,
    private ngZone: NgZone,
    private techDomainService: TechDomainService,
    private notificationService: NotificationService,
    private webSocketService: WebSocketService
  ) {
    this.windowInnerWith = window.innerWidth;
    window.onresize = (e) => {
    
      this.ngZone.run(() => {
        this.windowInnerWith = window.innerWidth;
        this.toggleMenuComponent();
      });
    };
    var self = this;
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)  
    ).subscribe((event: NavigationEnd) => {
      setTimeout( function(){
        self.profileCompleted = Number(localStorage.getItem('profileCompleted'));
        console.log(self.profileCompleted);
       }, 1000)
      if(event.url === '/research/all-research') {
      this.researchStl = true;
      this.aboutUsStl = false;
      this.contactUsStl = false;
      }
      else if(event.url === '/reports') {
        this.researchStl = true;
        this.aboutUsStl = false;
        this.contactUsStl = false;
      }
      else if(event.url === '/about-us') {
        this.aboutUsStl = true;
        this.researchStl = false;
        this.contactUsStl = false;
      }
      else if(event.url === '/support') {
        this.contactUsStl = true;
        this.researchStl = false;
        this.aboutUsStl = false;
      }
      else if(event.url === '/tech-buyer/research/all-research') {
        this.researchStl = true;
        this.aboutUsStl = false;
        this.contactUsStl = false;
      }
      else if(event.url === '/tech-vendor/all-market-data') {
        this.researchStl = true;
        this.aboutUsStl = false;
        this.contactUsStl = false;
      }
      else if(event.url === '/tech-analyst/research/all-research') {
        this.researchStl = true;
        this.aboutUsStl = false;
        this.contactUsStl = false;
      }
      else if(event.url === '/ecosystm-staff/research/all-research') {
        this.researchStl = true;
        this.aboutUsStl = false;
        this.contactUsStl = false;
      }
      else {
        this.researchStl = false;
        this.aboutUsStl = false;
        this.contactUsStl = false;
      }
    });
  
 /*   router.events.subscribe((val)=> {
     setTimeout( function(){
      self.profileCompleted = Number(localStorage.getItem('profileCompleted'));
      console.log(self.profileCompleted);
     }, 500)
     
   }) */
   // console.log(this.profileCompleted);
   // this.profileCompleted = sessionStorage.getItem('profileCompleted');
   // console.log(' this.profileCompleted',  this.profileCompleted);
  }
  ngOnDestroy() {
    // prevent memory leak when component destroyed
    if (this.checkCartChange) {
      this.checkCartChange.unsubscribe();
    }
    this.checkProfileUrlChange.unsubscribe();
    this.checkCartChange.unsubscribe();
    this.subscription.unsubscribe();
    this.techDomainListselected = {id: null, name: "View All"};
    this.techDomainData = [];
  }

  ngAfterViewInit() {
    this.toggleMenuComponent();
  }

  ngOnInit() {
    // this.getUnreadNotificationsCount();
    this.getTechDomainList();
    this.checkProfileUrlChange = this.userDetailService.onProfileUrlChange.subscribe((newUrl) => {
      this.userDetailsObject.profileUrl = newUrl;
      this.userDetailService.updateStorage("profileUrl", newUrl);
    });
    this.checkCartChange = this.userDetailService.onCartDataChange.subscribe((newCartLength) => {
      this.getCartData();
    });
    this.cartLength = 0;
    this.notificationChange = this.notificationService.sendNotificationMessage.subscribe((newCartLength) => {
      this.getNotificationCount(newCartLength);
    });
    this.blogURL = environment.BLOG_URL;
    this.ECOSYSTM_TV_URL = environment.ECOSYSTM_TV_URL;
    this.EVENTS_URL = environment.EVENTS_URL;
    this.wpAutoLoginUrl = environment.WP_AUTO_LOGIN_URL;
    this.mediaURL = environment.MEDIA;
    this.globalDataSharedService.getreceivedExpandedFlag().subscribe((param: boolean) => {
      //   console.log('leftMenuExpand param:', param);
         this.leftMenuExpand = param;
     });
     this.profileCompleted = Number(localStorage.getItem('profileCompleted'));
    this.appState.loggedIn.subscribe(
      (response: boolean) => {
        // Quick fix to resolve navbar issue
        const session = window.sessionStorage.getItem('userDetails');
        if (session && response) {
          this.loggedIn = response;
        } else {
          this.loggedIn = false;
        }
        if (this.loggedIn) {
          this.getRole();
          this.userDetails();
          this.getUnreadNotificationsCount();
          // this.subscription = this.webSocketService.updateuserBasedNotificationCount().subscribe((response)=>{
          //   this.notificationCount = this.notificationCount + response;
          // })
          // this.subscription = this.webSocketService.updateroleBasedNotificationCount().subscribe((response)=>{
          //   this.notificationCount = this.notificationCount + response;
          // })
          if( this.userRole === "tech-vendor"){
            this.getCartData();
          }
        }
      },
      error => { }
    );

    this.subscription = this.techDomainService.selectedDomainId.subscribe(
      (newSelectedIds) => {
        this.techDomainListselected.id = newSelectedIds;
        this.getTechDomainList();
        if (this.techDomainData) {
          this.techDomainListselected.name = this.techDomainData.find(x => x.id === this.techDomainListselected.id).name;
        }
    });
  this.subscription = this.webSocketService.updateuserBasedNotificationCount().subscribe((response)=>{
    this.notificationCount = this.notificationCount + response;
  })
  this.subscription = this.webSocketService.updateroleBasedNotificationCount().subscribe((response)=>{
    this.notificationCount = this.notificationCount + response;
  })
 
  }

  openLeftSideNav() {
    this.toggleSidebar = !this.toggleSidebar;
    this.leftSideMenuBar.emit(this.toggleSidebar);
    
    console.log(this.leftSideMenuBar, 'hello');
  }

  changeTechDomain(techDomain) {
    if (this.techDomainListselected.id !==  techDomain.id ) {
     if (!techDomain.id) {
        this.techDomainListselected = {id: null, name: "View All"};
        this.techDomainService.setCurrentSelectedIds(null);
     } else {
        this.techDomainListselected = techDomain;
        this.techDomainService.setCurrentSelectedIds(techDomain.id);
     }
    }
   }

  getTechDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe((techDomainResponse: any) => {
      this.techDomainData = techDomainResponse;
      const obj = {id: null , name : "View All"};
      this.techDomainData.unshift(obj);
      this.techDomainListselected.name = this.techDomainData.find(x => x.id === this.techDomainListselected.id).name;
      window.scroll(0, 0);
    });
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  getCartData() {
    if (localStorage.getItem('cartData')) {
      this.cartData = JSON.parse(localStorage.getItem('cartData'));
    } else {
      this.cartData = [];
    }
    this.cartLength = this.cartData ? this.cartData.length : 0;
  }
  getNotificationCount(newNotificationcount){
    newNotificationcount = Number(newNotificationcount);
    this.notificationCount = newNotificationcount -1;
  }
  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
    }
  }

  techBuyerNavtoAllResearchList() {
    this.removeSession();
    this.router.navigate(["tech-buyer/research/all-research"]);
  }
  removeSession() {
    sessionStorage.removeItem('BC4Url');
    sessionStorage.removeItem('BC4Label');
    sessionStorage.removeItem('BC3Url');
    sessionStorage.removeItem('BC3Label');
    sessionStorage.removeItem('BC2Url');
    sessionStorage.removeItem('BC2Label');
  }
  techVendorNavtoAllResearchList() {
    this.removeSession();
    this.router.navigate(["tech-vendor/all-market-data"]);
  }
  techAnalystNavtoAllResearchList() {
    this.removeSession();

    this.router.navigate(["tech-analyst/research/all-research"]);
  }
  techBuyerNavtoTrendingResearchList() {
    this.removeSession();

    this.router.navigate(["tech-buyer/research/trending-research"]);
  }

  techVendorNavtoTrendingResearchList() {
    this.removeSession();
    this.router.navigate(["tech-vendor/research/trending-research"]);
  }
  techAnalystNavtoTrendingResearchList() {

    this.removeSession();
    this.router.navigate(["tech-analyst/research/trending-research"]);
  }
  techBuyerNavtoAnalystList() {
    this.removeSession();
    this.breadcrumService.setUrl('BC2Label', 'Analyst List');
    this.breadcrumService.setUrl('BC2Url', 'analyst-list');
    this.router.navigate(["tech-buyer/analyst-list"]);
  }
  techVendorNavtoAnalystList() {
    this.removeSession();
    this.breadcrumService.setUrl('BC2Label', 'Analyst List');
    this.breadcrumService.setUrl('BC2Url', 'analyst-list');
    this.router.navigate(["tech-vendor/analyst-list"]);
  }

  techBuyerNavtoTechDomains() {
    this.removeSession();
    this.router.navigate(["tech-buyer/tech-domain-list"]);
  }
  techVendorNavtoTechDomains() {
    this.removeSession();
    this.router.navigate(["tech-vendor/tech-domain-list"]);
  }

  techBuyerNavtoSupport() {
    this.removeSession();
    this.router.navigate(["support"]);
  }

  techVendorNavtoSupport() {
    this.removeSession();
    this.router.navigate(["support"]);
  }

  techBuyerNavtoProfile() {
    this.removeSession();
    this.router.navigate(["tech-buyer/my-profile"]);
  }

  techVendorNavtoProfile() {
    this.removeSession();
    this.router.navigate(["tech-vendor/my-profile"]);
  }

  navtoCompleteProfile() {
    this.removeSession();
    this.router.navigate([`${this.userRole}/complete-my-profile`]);
  }

  techAnalystNavtoProfile() {
    this.removeSession();
    this.router.navigate(["tech-analyst/my-profile/about"]);
  }

  ecosystmStaffNavtoProfile() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff/my-profile"]);
  }

  techBuyerNavtoChangePassword() {
    this.removeSession();
    this.router.navigate(["tech-buyer/change-password"]);
  }

  techVendorNavtoChangePassword() {
    this.removeSession();
    this.router.navigate(["tech-vendor/change-password"]);
  }

  techAnalystNavtoChangePassword() {
    this.removeSession();
    this.router.navigate(["tech-analyst/change-password"]);
  }

  ecosystmStaffNavtoChangePassword() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff/change-password"]);
  }

  techAnalystNavtoBlogs() {
    this.removeSession();
    this.router.navigate(["tech-analyst/blogs"]);
  }

  navtoResearchList() {
    this.removeSession();
    this.router.navigate(["all-research"]);
  }
  navtoAnalystList() {
    this.removeSession();
    this.router.navigate(["analyst-list"]);
  }
  navtoVendorAssessmentTool() {
    this.removeSession();
    this.router.navigate(["tech-buyer/vendor-assessment-tool"]);
  }
  techVendorNavtoHome() {
    this.removeSession();
    this.router.navigate(["tech-vendor"]);
  }
  techVendorNavtoMySubscription() {
    this.removeSession();
    this.router.navigate(["tech-vendor/my-subscriptions"]);
  }
  techVendorNavtoBookmark() {
    this.removeSession();
    this.router.navigate(["tech-vendor/my-bookmarks"]);
  }
  techVendorNavtoMyConnection() {
    this.removeSession();
    this.router.navigate(["tech-vendor/my-connections"]);
  }
  techVendorNavtoSocial() {
    this.removeSession();
    this.router.navigate(["tech-vendor/social-feeds"]);
  }
  techVendorNavtoMessage() {
    this.removeSession();
    this.router.navigate(["tech-vendor/messages"]);
  }
  techVendorNavtoMeeting() {
    this.removeSession();
    this.router.navigate(["tech-vendor/my-meetings"]);
  }
  techVendorNavtoSubscriptions() {
    this.removeSession();
    this.router.navigate(["tech-vendor/subscriptions"]);
  }
  techVendorNavtoMyProjects() {
    this.removeSession();
    this.router.navigate(["tech-vendor/projects/pendingProjects"]);
  }
  techBuyerNavtoHome() {
    this.removeSession();
    this.router.navigate(["tech-buyer"]);
  }
  techBuyerNavtoMyResearch() {
    this.removeSession();
    this.router.navigate(["tech-buyer/my-research-list"]);
  }
  techBuyerNavtoMyProjects() {
    this.removeSession();
    this.router.navigate(["tech-buyer/projects/pendingProjects"]);
  }
  techBuyerNavtoBookmark() {
    this.removeSession();
    this.router.navigate(["tech-buyer/my-bookmarks"]);
  }
  techBuyerNavtoConnections() {
    this.removeSession();
    this.router.navigate(["tech-buyer/my-connections"]);
  }
  techBuyerNavtoSocial() {
    this.removeSession();
    this.router.navigate(["tech-buyer/social-feeds"]);
  }
  techBuyerNavtoMessage() {
    this.removeSession();
    this.router.navigate(["tech-buyer/messages"]);
  }
  techBuyerNavtoMeeting() {
    this.removeSession();
    this.router.navigate(["tech-buyer/my-meetings"]);
  }
  techBuyerNavtoVendorAssesmentTool() {
    this.removeSession();
    this.router.navigate(["tech-buyer/vendor-assessment-tool"]);
  }
  staffNavtoHome() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff"]);
  }
  staffNavtoBookmark() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff/my-bookmarks"]);
  }
  staffNavtoConnections() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff/my-connections"]);
  }
  staffNavtoSocial() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff/social-feeds"]);
  }
  staffNavtoMessage() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff/messages"]);
  }
  staffNavtoManageSubscription() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff/manage-subscription"]);
  }
  staffNavtoSalesBooking() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff/sales-booking"]);
  }
  techAnalystNavtoHome() {
    this.removeSession();
    this.router.navigate(["tech-analyst"]);
  }
  techAnalystNavtoMyReports() {
    this.removeSession();
    this.router.navigate(["tech-analyst/reports"]);
  }
  techAnalystNavtoMyProjects() {
    this.removeSession();
    this.router.navigate(["tech-analyst/projects/pendingProjects"]);
  }
  techAnalystNavtoBookmark() {
    this.removeSession();
    this.router.navigate(["tech-analyst/my-bookmarks"]);
  }
  techAnalystNavtoConnection() {
    this.removeSession();
    this.router.navigate(["tech-analyst/my-connections"]);
  }
  techAnalystNavtoMySocial() {
    this.removeSession();
    this.router.navigate(["tech-analyst/social-feeds"]);
  }
  techAnalystNavtoMessage() {
    this.removeSession();
    this.router.navigate(["tech-analyst/messages"]);
  }
  techAnalystNavtoMeeting() {
    this.removeSession();
    this.router.navigate(["tech-analyst/my-meetings"]);
  }
  techAnalystNavtoTransactions() {
    this.removeSession();
    this.router.navigate(["tech-analyst/transactions"]);
  }
  // navtoProducts() {
  //   this.router.navigate(['tech-vendor/change-password']);
  // }

  // navtoInsights() {
  //   this.router.navigate(['tech-vendor/change-password']);
  // }

  navtoAllResearchList() {
    this.removeSession();
    this.router.navigate(["research/all-research"]);
  }

  navtoReportsList() {
    this.removeSession();
    this.router.navigate(["reports"]);
  }
  navtoPackageSubsList() {
    this.removeSession();
    this.router.navigate(["package-subscription"]);
  }

  navtoBlogs() {
    let token = this.myAccessToken.getToken();
    if (token) {
      const blogUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}`;
      window.open(blogUrl, '_self');
    }
    else {
      window.open(this.blogURL, '_self');
    }
  }
  navtoSupport() {
    this.router.navigate(["support"]);
  }

  featureUnderConstructionNavigation() {
    this.removeSession();
    this.router.navigate([`under-construction`]);
  }

  techVendorNavtoSubscription() {
    this.removeSession();
    this.router.navigate(["tech-vendor/subscriptions"]);
  }

  navtoEvents() {
    let token = this.getToken();
    if (token) {
      const eventUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&redirect_url=events`;
      window.open(eventUrl, '_self');
    }
    else {
      window.open(this.EVENTS_URL, '_self')
    }
  }

  navtoEcosystmTv() {
    let token = this.getToken();
    if (token) {
      const eventUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&redirect_url=ecosystm-tv`;
      window.open(eventUrl, '_self');
    }
    else {
      window.open(this.ECOSYSTM_TV_URL, '_self');
    }
  }
  navRouteToMedia() {
    const token = this.getToken();
    if (token) {
      const mediaURL = `${this.wpAutoLoginUrl}?accesstoken=${token}&redirect_url=media`;
      window.open(mediaURL, '_self');
    } else {
      window.open(this.mediaURL, '_self');
    }
  }
  logout() {
    window.sessionStorage.removeItem('firstTimeSet');
    this.searchString = undefined;
    this.searchType = '';
    let filter = {
      search: undefined,
      type: '',
      limit: 10,
      skip: 0
    }
    this.rolesSharedService.updateMasterSearchQueryFilters(filter);
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.accessToken = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      ).accessToken;
      this.appState.logout(this.accessToken).subscribe(response => {
        this.onLogout();
      },
        err => {
          this.onLogout();
        });
    } else {
      this.onLogout();
    }
  }

  onLogout() {
    localStorage.clear();
    sessionStorage.clear();
    this.authenticationService.purgeAuth();
    this.router.navigate(["/signin"]);
    window.sessionStorage.clear();
    window.localStorage.setItem("logoutStatus", "true");
    this.appState.setState(false);
    this.loggedIn = false;
    this.techDomainService.setCurrentSelectedIds(null);
  }

  loginToContinue() {
    // fix reditect login
    this.router.navigate(["/signin"]);
  }

  techAnalystNavtoConnections() {
    this.router.navigate(['tech-analyst/my-connections']);
  }
  goToConnections() {
    this.router.navigate([`${this.userRole}/my-connections`]);
  }
  goToCart(){
    this.router.navigate([`${this.userRole}/subscriptions/cart`]);
  }

  techAnalystNavtoBookmarks() {
    this.router.navigate(['tech-analyst/tech-analyst-bookmarked-list']);
  }
  getToken() {
    let token = null;
    let userData = null;
    userData = JSON.parse(window.localStorage.getItem('userDetails'))
    if (userData) {
      token = userData.accessToken;
    }
    else {
      userData = JSON.parse(window.sessionStorage.getItem('userDetails'));
      token = userData != null ? userData.accessToken : null;
    }
    return token;
  }
  toggleMenuComponent() {
    if (!this.windowInnerWith) {
      this.windowInnerWith = window.innerWidth;
    }
    this.ngMediaQuery(this.windowInnerWith);
  }
  ngMediaQuery(screenWidth: number) {
    if (screenWidth >= 320 && screenWidth <= 991) {
      $('.navbar-collapse').collapse('hide');
      $('#sidebarRight').collapse('hide');
    }
  }
  getUnreadNotificationsCount(){
  this.notificationService.getUnreadNotificationCount().subscribe((response)=>{
    this.notificationCount = response['unreadNotificationCount'];
  })
  }
  goToNotifications(){
    this.router.navigate([`${this.userRole}/notifications`]);
  }
  inputBoxDisplay() {
    this.searchDisplay = true;
  }
  keyDownFunction(event?) {
    if(event.keyCode === 13) {
      if(this.searchString !== undefined) {
      let url = window.location.href;
      let urlRegex = /.*global-search.*/;
      let samePage = urlRegex.test(url);
      if (samePage === true) {
        this.rolesSharedService.searchFilter.subscribe(
          resp => this.searchType = resp.type
        );
      }
      if (samePage === false) {
        this.searchType = ''
      }

      let filter = {
        search: this.searchString,
        type: this.searchType,
        limit: this.limit,
        skip: this.skip
      }
      this.rolesSharedService.updateMasterSearchQueryFilters(filter);
      this.rolesSharedService.masterSearch(filter).subscribe((result) => {
        this.router.navigate([`/global-search`]);
        this.rolesSharedService.updateMasterSearchData(result);
      });
    }
  }
  }
  globalSearch() {
    if(this.searchString !== undefined) {
    let url = window.location.href;
    let urlRegex = /.*global-search.*/;
    let samePage = urlRegex.test(url);
    if (samePage === true) {
      this.rolesSharedService.searchFilter.subscribe(
        resp => this.searchType = resp.type
      );
    }
    if (samePage === false) {
      this.searchType = ''
    }

    let filter = {
      search: this.searchString,
      type: this.searchType,
      limit: this.limit,
      skip: this.skip
    }
    this.rolesSharedService.updateMasterSearchQueryFilters(filter);
    this.rolesSharedService.masterSearch(filter).subscribe((result) => {
      this.router.navigate([`/global-search`]);
      this.rolesSharedService.updateMasterSearchData(result);
    });
  }
}
  resendVerificationEmail() {
    this.authenticationService.resendVerificationEmail(this.userDetailsObject.email).subscribe(
      response => {

        swal("Success", "Please check your email", "success");
      },
      error => {

        swal("Info", error.error.error.message, "info");
      }
    );
  }

  navToCreateProject(){
    this.router.navigate([`${this.userRole}/create-project/project-form-common`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/top-nav-bar/top-nav-bar.component.ts